/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-status-dot',
    template: '',
    styleUrls: ['./status-dot.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StatusDotComponent {
}
